import { localize, pickLocalizedField } from 'mixins/helpers';

export const ADS = [
    {
        value: 'INITIATION_BANKRUPTCY_ANNOUNCEMENT',
        label: 'find-ads-full-announcement-bankruptcy',
    },
    {
        value: 'INITIATION_REHABILITATION_ANNOUNCEMENT',
        label: 'find-ads-full-announcement-proceedings',
    },

    {
        value: 'DECLARING_BANKRUPT_ANNOUNCEMENT',
        label: 'find-ads-full-announcement-recognition',
    },
    {
        value: 'BANKRUPTCY_MEETING_NOTICE',
        label: 'find-ads-full-notification-bankruptcy',
    },
    {
        value: 'REHABILITATION_MEETING_NOTICE',
        label: 'find-ads-full-notification-rehabilitation',
    },
    {
        value: 'LIQUIDATION_BANKRUPT_ANNOUNCEMENT',
        label: 'find-ads-full-announcement-liquidation',
    },
    
];

export const INITIATION_BANKRUPTCY_ANNOUNCEMENT = (translations: any, lang: string) => {
    return [
        {
            title: localize('region', translations),
            render: (row: any) => pickLocalizedField(row, lang, ['region']),
        },
        {
            title: localize('find-ads-full-name', translations),
            dataIndex: 'debtor',
            render: (debtor: any) => pickLocalizedField(debtor, lang),
        },
        {
            title: localize('find-ads-full-debtor-iin', translations),
            dataIndex: ['debtor', 'taxpayerCode'],
        },
        {
            title: localize('find-ads-full-debtor-location', translations),
            dataIndex: ['debtor'],
            render: (debtor: any) => pickLocalizedField(debtor, lang, ['address']),
        },
        {
            title: localize('find-ads-full-bankruptcy-proceedings', translations),
            dataIndex: ['court'],
            render: (court: any) => pickLocalizedField(court, lang, ['name']),
        },
        {
            title: localize('find-ads-full-date-ruling', translations),
            dataIndex: 'court',
            render: (court: any) =>
                court.courtDate && court.courtDate.substring(0, 10).split('-').reverse().join('.'),
        },
        {
            title: localize('find-ads-full-surname-temporary-manager', translations),
            dataIndex: 'admin',
            render: (admin) =>
                (admin.lastName ?? '') +
                ' ' +
                (admin.firstName ?? '') +
                ' ' +
                (admin.middleName ?? ''),
        },
        {
            title: localize('find-ads-full-deadline-temporary-manager', translations),
            children: [
                {
                    title: localize('find-ads-from', translations),
                    dataIndex: 'beginDate',
                    width: '5%',
                    render: (beginDate) =>
                        beginDate && beginDate.substring(0, 10).split('-').reverse().join('.'),
                },
                {
                    title: localize('find-ads-to', translations),
                    dataIndex: 'endDate',
                    width: '5%',
                    render: (endDate) =>
                        endDate && endDate.substring(0, 10).split('-').reverse().join('.'),
                },
            ],
        },
        {
            title: localize('find-ads-full-address-requirements', translations),
            render: (row: any) => pickLocalizedField(row, lang, ['rtkAddress']),
        },
        {
            title: localize('find-ads-full-contact-details', translations),
            dataIndex: 'admin',
            render: (admin) => admin.phone + ' ' + admin.email,
        },
        {
            title: localize('find-ads-full-placement-date', translations),
            dataIndex: 'createdDate',
            render: (createdDate) =>
                createdDate && createdDate.substring(0, 10).split('-').reverse().join('.'),
        },
    ];
};

export const DECLARING_BANKRUPT_ANNOUNCEMENT = (translations: any, lang: string) => {
    return [
        {
            title: localize('region', translations),
            render: (row: any) => pickLocalizedField(row, lang, ['region']),
        },
        {
            title: localize('find-ads-full-name', translations),
            dataIndex: 'debtor',
            render: (debtor: any) =>
                pickLocalizedField(debtor, lang) ||
                [debtor.lastName, debtor.firstName, debtor.middleName].filter(Boolean).join(' '),
        },
        {
            title: localize('find-ads-full-debtor-iin', translations),
            dataIndex: ['debtor', 'taxpayerCode'],
        },
        {
            title: localize('find-ads-full-debtor-location', translations),
            dataIndex: ['debtor'],
            render: (debtor: any) => pickLocalizedField(debtor, lang, ['address']),
        },
        {
            title: localize('find-ads-full-information-state-registration', translations),
            dataIndex: 'regInfo',
        },
        {
            title: localize('find-ads-full-name-decision-declaring', translations),
            dataIndex: ['court'],
            render: (court: any) => pickLocalizedField(court, lang, ['name']),
        },
        {
            title: localize('find-ads-full-date-decision', translations),
            dataIndex: 'court',
            render: (court) =>
                court.courtDate && court.courtDate.substring(0, 10).split('-').reverse().join('.'),
        },
        {
            title: localize('find-ads-full-placement-date', translations),
            dataIndex: 'createdDate',
            render: (createdDate) =>
                createdDate && createdDate.substring(0, 10).split('-').reverse().join('.'),
        },
    ];
};

export const BANKRUPTCY_MEETING_NOTICE = (translations: any, lang: string = 'ru') => {
    return [
        {
            title: localize('region', translations),
            render: (row: any) => pickLocalizedField(row, lang, ['region']),
        },
        {
            title: localize('find-ads-full-name', translations),
            dataIndex: 'debtor',
            render: (debtor: any) =>
                pickLocalizedField(debtor, lang, ['']) ||
                [debtor.lastName, debtor.firstName, debtor.middleName].filter(Boolean).join(' '),
        },
        {
            title: localize('find-ads-full-debtor-iin', translations),
            dataIndex: ['debtor', 'taxpayerCode'],
        },
        {
            title: localize('find-ads-full-debtor-location', translations),
            render: (row: any) => pickLocalizedField(row.debtor, lang, ['address']),
        },
        {
            title: localize('find-ads-full-date-meeting', translations),
            dataIndex: 'meetingDate',
            render: (meetingDate) =>
                meetingDate && meetingDate.substring(0, 10).split('-').reverse().join('.'),
        },
        {
            title: localize('find-ads-full-time-meeting', translations),
            dataIndex: 'meetingDate',
            render: (meetingDate) => meetingDate && meetingDate.substring(11, 16),
        },
        {
            title: localize('find-ads-full-venue-meeting', translations),
            render: (row: any) => pickLocalizedField(row, lang, ['meetingPlace']),
        },
        {
            title: localize('find-ads-full-agenda-meeting', translations),
            dataIndex: 'meetingAgenda',
        },
        {
            title: localize('find-ads-full-procedure', translations),
            dataIndex: 'meetingFamiliarization',
        },
        {
            title: localize('find-ads-full-contact-details', translations),
            dataIndex: 'admin',
            render: (admin) => admin.phone + ' ' + admin.email,
        },
        {
            title: localize('find-ads-full-placement-date', translations),
            dataIndex: 'createdDate',
            render: (createdDate) =>
                createdDate && createdDate.substring(0, 10).split('-').reverse().join('.'),
        },
    ];
};

export const getColumnsByType = (
    type: string,
    translations: Record<string, string>,
    lang: string = 'ru'
) => {
    switch (type) {
        case 'INITIATION_BANKRUPTCY_ANNOUNCEMENT':
            return INITIATION_BANKRUPTCY_ANNOUNCEMENT(translations, lang);
        case 'INITIATION_REHABILITATION_ANNOUNCEMENT':
            return INITIATION_BANKRUPTCY_ANNOUNCEMENT(translations, lang);
        case 'DECLARING_BANKRUPT_ANNOUNCEMENT':
            return DECLARING_BANKRUPT_ANNOUNCEMENT(translations, lang);
        case 'BANKRUPTCY_MEETING_NOTICE':
            return BANKRUPTCY_MEETING_NOTICE(translations, lang);
        case 'REHABILITATION_MEETING_NOTICE':
            return BANKRUPTCY_MEETING_NOTICE(translations, lang);
        default:
            return [];
    }
};
